// i18n Configuration
// For now, only French is supported. More languages can be added later.

export type SupportedLanguage = 'fr';

export const DEFAULT_LANGUAGE: SupportedLanguage = 'fr';

export const SUPPORTED_LANGUAGES: SupportedLanguage[] = ['fr'];

// Language configuration
export const i18nConfig = {
  defaultLanguage: DEFAULT_LANGUAGE,
  supportedLanguages: SUPPORTED_LANGUAGES,
  // Future: Add language detection, persistence, etc.
};

